module.exports = __webpack_public_path__ + "img/dreamweaver.bd44a953.png";